import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.v6t_1 = id;
        this.w6t_1 = name;
        this.x6t_1 = email;
        this.y6t_1 = badge;
        this.z6t_1 = callSignAdjective;
        this.a6u_1 = callSignNoun;
        this.b6u_1 = imageURL;
        this.c6u_1 = avatarType;
        this.d6u_1 = unvalidatedEmails;
        this.e6u_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.v6t_1.toString() + ', name=' + this.w6t_1 + ', email=' + this.x6t_1 + ', badge=' + toString(this.y6t_1) + ', callSignAdjective=' + this.z6t_1 + ', callSignNoun=' + this.a6u_1 + ', imageURL=' + toString(this.b6u_1) + ', avatarType=' + toString(this.c6u_1) + ', unvalidatedEmails=' + toString(this.d6u_1) + ', pins=' + toString(this.e6u_1) + ')';
      }
      hashCode() {
        var result = this.v6t_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.w6t_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x6t_1) | 0;
        result = imul(result, 31) + hashCode(this.y6t_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z6t_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6u_1) | 0;
        result = imul(result, 31) + hashCode(this.b6u_1) | 0;
        result = imul(result, 31) + hashCode(this.c6u_1) | 0;
        result = imul(result, 31) + hashCode(this.d6u_1) | 0;
        result = imul(result, 31) + hashCode(this.e6u_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.v6t_1.equals(other.v6t_1))
          return false;
        if (!(this.w6t_1 === other.w6t_1))
          return false;
        if (!(this.x6t_1 === other.x6t_1))
          return false;
        if (!equals(this.y6t_1, other.y6t_1))
          return false;
        if (!(this.z6t_1 === other.z6t_1))
          return false;
        if (!(this.a6u_1 === other.a6u_1))
          return false;
        if (!equals(this.b6u_1, other.b6u_1))
          return false;
        if (!equals(this.c6u_1, other.c6u_1))
          return false;
        if (!equals(this.d6u_1, other.d6u_1))
          return false;
        if (!equals(this.e6u_1, other.e6u_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
